import React, { useState } from "react";
import PropTypes from "prop-types";

import ReactSlider from "react-slider";
import { LoadingIndicator } from "../../../../components/simple";

import { formatNumber, formatPercentage } from "../../../../helpers/formatter";
import styles from "./precision-slider.module.scss";
import "./precision-slider.scss";

const PrecisionSlider = ({
  value,
  reach,
  population,
  precision,
  qualityIndicator,
  onChange,
  onAfterChange,
  disabled,
  isLoading,
  isLoadingStats
}) => {
  const [dragStarted, setDragStarted] = useState(false);
  const indicator = qualityIndicator && qualityIndicator.toLowerCase();
  return (
    <div
      className={`${styles["slider-container"]} ${
        disabled ? styles["slider-disabled"] : ""
      }`}
    >
      {/* <div className={styles["slider-header"]}>
        <div>Reach</div>
        <div>Precision</div>
      </div> */}
      {isLoadingStats ? (
        <div className={styles["slider-loader"]}>
          <LoadingIndicator variant="dark" />
        </div>
      ) : null}
      <div
        className={`${styles["slider-data"]} ${
          isLoading ? styles["is-loading"] : ""
        }`}
      >
        <div className="mr-1 ml-1">
          <span>{population && formatNumber(population)}</span>
          <span className={styles["slider-data-label"]}>People</span>
        </div>
        <div className="mr-1 ml-1">
          <span>{reach && formatPercentage(reach)}</span>
          <span className={styles["slider-data-label"]}>Population</span>
        </div>
        <div className={styles["slider-data-affinity-wrapper"]}>
          <div
            className={`${styles["slider-data-affinity-color"]} ${styles[indicator]}`}
          ></div>
          {precision ? (
            <>
              <span
                className={`${styles["slider-data-affinity-value"]} ${styles[indicator]}`}
              >
                {precision && precision.toFixed(1)}
              </span>
              <span className={styles["slider-data-label"]}>
                {indicator
                  ? indicator[0].toUpperCase() + indicator.slice(1)
                  : null}
              </span>
            </>
          ) : (
            <span className={styles["slider-data-label"]}>
              {indicator
                ? indicator[0].toUpperCase() + indicator.slice(1)
                : null}
            </span>
          )}
        </div>
      </div>
      <div style={{ position: "relative", width: "100%", height: 20 }}>
        <ReactSlider
          invert
          className={styles.slider}
          thumbClassName={styles.thumb}
          trackClassName={styles.track}
          value={value}
          onChange={onChange}
          onAfterChange={onAfterChange}
          onBeforeChange={() => {
            setDragStarted(true);
          }}
          onSliderClick={s => {
            if (!dragStarted) {
              onAfterChange(s);
            }
            setDragStarted(false);
          }}
          renderThumb={props => (
            <div {...props}>
              <div className={styles["thumb-inner"]}></div>
            </div>
          )}
        />
      </div>
      <div className={styles["slider-footer"]}>
        <div>High precision</div>
        <div>High reach</div>
      </div>
    </div>
  );
};

PrecisionSlider.propTypes = {
  value: PropTypes.number.isRequired,
  reach: PropTypes.number,
  population: PropTypes.number,
  precision: PropTypes.number,
  qualityIndicator: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onAfterChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingStats: PropTypes.bool
};

PrecisionSlider.defaultProps = {
  reach: 0,
  population: 0,
  precision: 0,
  qualityIndicator: "",
  disabled: false,
  isLoading: false,
  isLoadingStats: false
};

export default PrecisionSlider;
